module.exports = __webpack_public_path__ + "img/bg_sec03_3.7228bbb8.jpg";